import { HomeGroupLayout, InviteOrganizationGroupHostForm } from 'components';
import React from 'react';


/**
 * 機構邀請老師頁面
 */

export const HomeInviteOrganizationHostPage = () => {
  return (
    <HomeGroupLayout>
      <InviteOrganizationGroupHostForm />
    </HomeGroupLayout>
  );
};

